// extracted by mini-css-extract-plugin
export var deliveryRow = "_o4-a";
export var fixedHeight = "_o4-4";
export var freightLogo = "_o4-9";
export var fullWidth = "_o4-3";
export var priceColumn = "_o4-5";
export var radioSelected = "_o4-7";
export var radioUnselected = "_o4-6";
export var selectedOption = "_o4-2";
export var selectedOptionContainer = "_o4-1";
export var selection = "_o4-0";
export var tallSkeletonText = "_o4-8";